export default "__VITE_PUBLIC_ASSET__db3d85cc__"